/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["label[_ngcontent-%COMP%]{width:100%}input[_ngcontent-%COMP%]{width:100%;height:100%}[_nghost-%COMP%]{display:inline-block}.fa-clock[_ngcontent-%COMP%]{color:#cfcfcf;font-size:12px;display:flex;justify-content:center}"];
export { styles as styles };
